module.exports = __webpack_public_path__ + "img/empty.4ff9271c.png";